
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#0A1F38] via-[#0F2A4A] to-[#1E4D7B]">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/282c26880d22afa29b04cf725ef22d20.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div className="space-y-4">
              <h1 className="text-7xl lg:text-8xl font-black text-white leading-tight font-serif">
                讓老屋重生
              </h1>
              <h2 className="text-4xl lg:text-5xl font-bold text-white/95 leading-tight">
                讓裝修後的家真正完成入住
              </h2>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <span className="px-5 py-2 bg-white/90 text-primary text-sm font-medium rounded-full">
                裝修
              </span>
              <span className="text-white/60">|</span>
              <span className="px-5 py-2 bg-white/90 text-primary text-sm font-medium rounded-full">
                翻新
              </span>
              <span className="text-white/60">|</span>
              <span className="px-5 py-2 bg-white/90 text-primary text-sm font-medium rounded-full">
                軟裝
              </span>
              <span className="text-white/60">|</span>
              <span className="px-5 py-2 bg-white/90 text-primary text-sm font-medium rounded-full">
                出租裝修
              </span>
            </div>

            <p className="text-xl text-white/90 font-light">
              一站式整合服務
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="https://lin.ee/JAWndnI"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-primary text-white rounded-full text-base font-medium hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                加入LINE諮詢
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://go.hotcake.app/g/VB3HEP"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-primary rounded-full text-base font-medium hover:bg-white/90 transition-all border-2 border-white flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                預約到府評估
                <i className="ri-calendar-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2 relative hidden lg:block">
            <div className="relative">
              <div className="absolute -top-12 -right-12 w-80 h-80 bg-gradient-to-br from-[#4A90C2]/30 to-[#1E4D7B]/30 rounded-[40px] rotate-12 blur-sm"></div>
              <div className="absolute top-12 right-0 w-72 h-72 bg-gradient-to-br from-[#1E4D7B]/40 to-[#4A90C2]/20 rounded-[40px] -rotate-6 blur-sm"></div>
              <div className="absolute top-24 -right-6 w-64 h-64 bg-gradient-to-br from-[#4A90C2]/25 to-[#0F2A4A]/30 rounded-[40px] rotate-3"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
